module.exports = __webpack_public_path__ + "img/Cleaning Services.9a768ca4.svg";